<template>
  <div>
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">Account Managers</h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <button
            class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
            @click="addAccountManager"
          >
            <i class="fas fa-plus"></i> Add account manager
          </button>
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Account Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <div class="text-center">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>User ID</th>
                      <th>Email</th>
                      <th>Full Name</th>
                      <th>WhatsApp</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in items"
                      :key="index"
                      class="pointer"
                      @click="openDetail(item)"
                    >
                      <td>{{item.userId}}</td>
                      <td>
                        {{item.user.email}}
                      </td>
                      <td>{{item.user.firstName}} {{item.user.lastName}}</td>
                      <td>{{item.contactInfo.whatsapp}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/config"

export default {
  name: "AccountManagerList",
  data() {
    return {
      items: [],
      isLoading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.$http
        .get(Config.api.accountManager)
        .then(res => {
          this.items = res.body.accountManagers
        }, () => {
          this.$toasted.error('Failed to load account managers')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    openDetail(item) {
      this.$router.push({ name: "AccountManagerDetails", params: { id: item.userId } })
    },
    addAccountManager() {
      this.$router.push({ name: "AccountManagerDetails", params: { id: "new" } })
    },
  }
}
</script>
